import request from '@/util/request';
import qs from 'qs';


// 获取列表
export const getProjectList = (params, options) =>
    request.get('/api/v4ward/project/getProjectList', Object.assign({}, options, { params }));

// 字典
export const getDictData = (params, options) =>
    request.get('/api/blade-system/dict/dictionary', Object.assign({}, options, { params }));

// 能耗首页-本月用电水等
export const projectMonthEnergy = (params, options) =>
    request.get('/api/v4ward/energy/statistic/projectMonthEnergy', Object.assign({}, options, { params }));


// 能耗首页-日小时能耗

export const projectDailyEnergy = (params, options) =>
    request.get('/api/v4ward/energy/statistic/projectDailyEnergy', Object.assign({}, options, { params }));

//     能耗首页-仪表报警列表
export const projectWarnings = (params, options) =>
    request.get('/api/v4ward/energy/statistic/projectWarnings', Object.assign({}, options, { params }));

//     能耗首页-部门能耗排名
export const projectEnergyRank = (params, options) =>
    request.get('/api/v4ward/energy/statistic/projectEnergyRank', Object.assign({}, options, { params }));



// 能耗首页-设备状态统计
export const projectDeviceStatus = (params, options) =>
    request.get('/api/v4ward/energy/statistic/projectDeviceStatus', Object.assign({}, options, { params }));

// 根据部门能耗id获取指标参数集合 //v4ward/energy/setting/dept/cost/meter/getListByDeptCostId
export const metergetListByDeptCostId = (params, options) =>
    request.get('/api/v4ward/energy/setting/dept/cost/meter/getListByDeptCostId', Object.assign({}, options, { params }));